import React, { Component } from 'react';

class InputCheckbox extends Component {    
  
  render() {
    var cols = 12;
    if (this.props.label) cols -=4;
    //if (this.props.sublabel) cols -=4;
    return (
        <div className="row form-group justify-content-start">
            {this.props.label &&
            <label className="col-sm-4 col-form-label">{this.props.label}</label>
            }
            <div className={`col-xl-${cols}`}>
                <input
                  type='checkbox'
                  id={this.props.id}
                  checked={this.props.checked}
                  onChange={this.props.onChange}
                  style={{zoom: "1.3", width: "26px", height: "26px", marginRight: "6px"}}
                  disabled={this.props.disabled}
                />
                {this.props.sublabel}
            </div>
            {false && this.props.sublabel &&
              <label className="col-sm-4 col-form-label">{this.props.sublabel}</label>
            }
        </div>
      );
  }
}

export default InputCheckbox;